<template>
    <div class="md-layout">
        <div class="md-layout-item">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-blue">
                    <div class="card-icon">
                        <md-icon>apartment</md-icon>
                    </div>
                    <h4 class="title"><span v-if="!allBuildings">{{portfolioName}} - </span>Buildings</h4>
                </md-card-header>
                <md-card-content>
                    <div id="filters" class="filters">
                        <span class="wrap">
                            <a @click="toggleFilters" class="filter_toggle round_hover_btn" :class="{ shown: colFiltersVisible }" tabindex="0">
                                <i class="fa fa-chevron-circle-down"></i>
                            </a>
                        </span>
                    </div>
                    <table v-if="renderComponent" id="table_main" class="display" width="100%"><thead></thead><tbody></tbody><tfoot><tr></tr></tfoot></table>
                </md-card-content>
            </md-card>
        </div>
    </div>
</template>

<script>
    import AcTables from "@/ts/ac.tables";
    import Api from '@/ts/UvApiService';
    import Help from "@/ts/Help";
    import Swal from "sweetalert2";

    window.vmBuildingsIndex = null;

    export default {
        methods: {
            navigate(event, element) {
                event.preventDefault();
                var t = element.getAttribute("href");
                this.$router.push(t);
                return false;
            },
            toggleFilters() {
                this.colFiltersVisible = AcTables.toggleFilters();
            },
            deleteBuilding(name, id) {
                Swal.fire({
                    title: "Are you sure?",
                    text: `You won't be able to revert this!`,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "md-button md-success btn-fill",
                    cancelButtonClass: "md-button md-danger btn-fill",
                    confirmButtonText: "Yes, delete it!",
                    buttonsStyling: false
                }).then(result => {
                    if (result.value) {
                        //TODO:flesh this.deleteRow(item);
                        Swal.fire({
                            title: "Deleted!",
                            text: `You deleted ${name}`,
                            type: "success",
                            confirmButtonClass: "md-button md-success btn-fill",
                            buttonsStyling: false
                        });
                    }
                });
            },
            async setup() {
                this.teardown();
                this.$nextTick(async () => {
                    this.portfolioId = this.$route.params.portfolioId;
                    window.vmBuildingsIndex = this;
                    var allJson = await Api.buildings.getBuildings(this.portfolioId);
                    this.portfolioName = allJson.meta.portfolioName;
                    window.vmBuildingsIndex = this;
                    this.dataTable = AcTables.initTable("table_main", allJson.tableJson);
                });
            },
            teardown() {
                window.vmBuildingsIndex = null;
                if (this.dataTable) {
                    this.dataTable.destroy();
                }
                this.dataTable = null;
                this.forceRerender();
            },
            forceRerender() {
                this.renderComponent = false; // Remove my-component from the DOM
                this.$nextTick(() => {
                    this.renderComponent = true;  // Add the component back in
                });
            },
        },
        created() {
            this.portfolioId = this.$route.params.portfolioId;
            window.vmBuildingsIndex = this;
        },
        async mounted() {
                await this.setup();
        },
        beforeDestroy() {
            this.teardown();
        },
        watch: {
            '$route'() {
                this.$nextTick(function () {
                    this.portfolioId = this.$route.params.portfolioId;
                });
            },
        //    async portfolioId() {
        //        this.$nextTick(async function () {
        //            await this.setup();
        //        });
        //    }
        },
        data() {
            return {
                renderComponent: true,
                colFiltersVisible: false,
                dataTable: null,
                //optional //url: null,
                portfolioId: null,
                portfolioName: ""
            }
        },
        computed: {
            allBuildings() {
                return Help.isNullOrUndef(this.portfolioId);
            },
        },
    };
</script>

<style lang="scss">

</style>